import React from 'react';
import App, { PassageSlim } from 'codeArt/external/containers/App';
import { Route, Switch, withRouter } from 'react-router-dom';
import asyncComponent from '../util/asyncComponent';
import { MenuRoot, MenuGroup, Menu, MenuItem } from 'codeArt/components/Menu';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupIcon from '@material-ui/icons/Group';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import StorageIcon from '@material-ui/icons/Storage';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { RequestConfig, Notification, Request } from 'codeArt/common';
import Backdrop from 'codeArt/components/Backdrop';
import { DomainConfig } from 'js/context';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import { ExplorerConfig } from 'codeArt/components/Explorer';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import BarChartIcon from '@material-ui/icons/BarChart';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import WidgetsIcon from '@material-ui/icons/Widgets';
import ShortTextIcon from '@material-ui/icons/ShortText';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DeveloperBoardOutlinedIcon from '@material-ui/icons/DeveloperBoardOutlined';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import LoyaltyOutlinedIcon from '@material-ui/icons/LoyaltyOutlined';
import { Principal } from 'codeArt/auth';
import { toSignin } from 'app';

export default class Index extends React.Component {

  constructor(props) {
    super(props);
  }

  login(cb) {
    Request({
      url: "/enter",
      success: (r) => {
        Principal.setAuth(r);
        cb();
      }, error: (e) => {
        toSignin(e);
      }
    });
  }

  init(cb) {
    RequestConfig.domain = DomainConfig.main;
    RequestConfig.uploadUrl = DomainConfig.file + "/upload.htm";

    ExplorerConfig.set({
      getRoots: "/getPlatFormExplorerRoots",
      getDirectory: "/getPlatFormDirectory",

      getVirtualDirectory: "/getVirtualDirectory",
      getRootDirectory: "/getRootDirectory",
      getItems: "/getExplorerItems",
      createDirectory: "/createDirectory",
      "delete": "/deleteExplorerItems",
      rename: "/renameExplorerItem",
      moveFiles: "/moveFiles",
    });


    Principal.getItemKey = (key) => {
      return key;
    }

    this.login(cb);
  }

  menus() {
    let { match } = this.props;
    return (
      <MenuRoot>
        <MenuGroup title="开始">
          <MenuItem className="menu no-arrow" to={`${match.url}/home`}>首页</MenuItem>
          <MenuItem className="menu no-arrow" to={`${match.url}/marketer/index`}>营销号</MenuItem>
        </MenuGroup>

        <MenuGroup title="云数据">
          <Menu title="需求管理" icon={LoyaltyOutlinedIcon}>
            <MenuItem to={`${match.url}/demand/role/persona/feature`}>人物特征</MenuItem>
            <MenuItem to={`${match.url}/demand/humanity/index`}>心理动机</MenuItem>
          </Menu>
          {/* <MenuItem className="menu no-arrow" icon={TrendingUpIcon} to={`${match.url}/cloud/trend`}>新趋势</MenuItem> */}
          {/* <MenuItem className="menu no-arrow" icon={AspectRatioIcon} to={`${match.url}/cloud/marketSize`}>市场规模</MenuItem> */}
          <Menu title="营销调研" icon={FindReplaceIcon}>
            {/* <MenuItem to={`${match.url}/cloud/topic`}>主题</MenuItem> */}
            {/* <MenuItem to={`${match.url}/cloud/research/questionnaire/index`}>问卷库</MenuItem> */}
            <MenuItem to={`${match.url}/research/interview/index`}>访谈模板</MenuItem>
          </Menu>
          <Menu title="企业管理" icon={BarChartIcon}>
            <MenuItem to={`${match.url}/cloud/cpc`}>核心效益指标</MenuItem>
            <MenuItem to={`${match.url}/cloud/bl`}>商业逻辑</MenuItem>
            <MenuItem to={`${match.url}/cloud/okr/grow`}>GROW题库</MenuItem>
            <MenuItem to={`${match.url}/cloud/okr/rmgt`}>角色使命思考清单</MenuItem>
            <MenuItem to={`${match.url}/cloud/okr/pras`}>评分后复盘要点</MenuItem>
            <MenuItem to={`${match.url}/cloud/okr/checker`}>OKR检查清单</MenuItem>
            <MenuItem to={`${match.url}/cloud/okr/rc`}>OKR回顾对话</MenuItem>
          </Menu>
         
          {/* <Menu title="顾客行为">
            <MenuItem to={`${match.url}/consumer/group`}>群体影响</MenuItem>
            <MenuItem to={`${match.url}/consumer/schema`}>图式记忆</MenuItem>
          </Menu> */}

          {/*           <Menu title="品牌联想">
            <MenuItem to={`${match.url}/lenovo/category`}>联想分类</MenuItem>
          </Menu> */}

          {/* <Menu title="其他">
            <MenuItem to={`${match.url}/research/questionnaire`}>问卷调查</MenuItem>
            <MenuItem to={`${match.url}/marketer/market`}>市场</MenuItem>
            <MenuItem to={`${match.url}/marketer/demandPoint`}>需求点</MenuItem>
          </Menu> */}
        </MenuGroup>

        {/*         <MenuGroup title="客户">
          <Menu title="用户画像">
            <MenuItem to="/app/client/persona/template">画像模板</MenuItem>
          </Menu>
        </MenuGroup> */}
        {/* 
        <MenuGroup title="乐购">
          <Menu title="商品">
            <MenuItem to={`${match.url}/saleable/redemption`}>兑换专区</MenuItem>
          </Menu>
        </MenuGroup> */}
        <MenuGroup title="学习">
          <Menu title="书籍" icon={MenuBookIcon}>
            <MenuItem to={`${match.url}/book/want`}>使用申请</MenuItem>
            <MenuItem to={`${match.url}/book/analyze/index`}>统计分析</MenuItem>
            <MenuItem to={`${match.url}/book/index`}>书籍管理</MenuItem>
          </Menu>
          {/*      <Menu title="标语" icon={ShortTextIcon}>
            <MenuItem to={`${match.url}/slogan/home/welcome`}>首页欢迎语</MenuItem>
          </Menu> */}
          <Menu title="海报" icon={ReceiptIcon}>
            <MenuItem to={`${match.url}/poster/theme/index`}>主题</MenuItem>
            {/*             <MenuItem to={`${match.url}/poster/template/index`}>模板</MenuItem> */}
          </Menu>
          <Menu title="日志" icon={AssignmentIcon}>
            <MenuItem to={`${match.url}/log/page/index`}>页面访问</MenuItem>
            <MenuItem to={`${match.url}/log/rpc/index`}>远程调用</MenuItem>
            <MenuItem to={`${match.url}/log/ui/index`}>界面操作</MenuItem>
            <MenuItem to={`${match.url}/log/records`}>条目</MenuItem>
          </Menu>
        </MenuGroup>

        <MenuGroup title="设置">
          <MenuItem icon={StorageIcon} className="menu no-arrow" to={`${match.url}/setting/disk/index`}>磁盘管理</MenuItem>
          <Menu title="用户及控制" icon={SettingsIcon}>
            <MenuItem to={`${match.url}/setting/auth/user`}>用户授权</MenuItem>
            <MenuItem to={`${match.url}/setting/auth/role/index`}>角色管理</MenuItem>
            <MenuItem to={`${match.url}/setting/auth/feature`}>功能设置</MenuItem>
            <MenuItem to={`${match.url}/setting/auth/permission`}>权限设置</MenuItem>
            <MenuItem to={`${match.url}/setting/auth/db`}>数据库</MenuItem>
          </Menu>
          <MenuItem icon={DeveloperBoardOutlinedIcon} className="menu no-arrow" to={`${match.url}/setting/developer/index`}>开发者设置</MenuItem>
        </MenuGroup>
        {/* 
        <MenuGroup title="基础管理">
          <MenuItem className="menu no-arrow" to="/app/note/index">注解</MenuItem>
        </MenuGroup> */}
      </MenuRoot>
    )
  }

  render() {
    let { match, history } = this.props;
    return (
      <App name="a" init={this.init.bind(this)} menus={this.menus()} passage={(e) => { this.refs.passage.open(e); }}>
        <Switch>
          <Route path={`${match.url}/home`} component={asyncComponent(() => import('./routes/home'))} />
          <Route path={`${match.url}/research`} component={asyncComponent(() => import('./routes/research'))} />
          <Route path={`${match.url}/cloud`} component={asyncComponent(() => import('./routes/cloud'))} />
          <Route path={`${match.url}/consumer`} component={asyncComponent(() => import('./routes/consumer'))} />
          <Route path={`${match.url}/demand`} component={asyncComponent(() => import('./routes/demand'))} />
          <Route path={`${match.url}/lenovo`} component={asyncComponent(() => import('./routes/lenovo'))} />
          <Route path={`${match.url}/log`} component={asyncComponent(() => import('./routes/log'))} />
          <Route path={`${match.url}/marketer`} component={asyncComponent(() => import('./routes/marketer'))} />
          <Route path={`${match.url}/saleable`} component={asyncComponent(() => import('./routes/saleable'))} />
          <Route path={`${match.url}/setting`} component={asyncComponent(() => import('./routes/setting'))} />
          <Route path={`${match.url}/book`} component={asyncComponent(() => import('./routes/book'))} />
          {/*           <Route path={`${match.url}/slogan`} component={asyncComponent(() => import('./routes/slogan'))} /> */}
          <Route path={`${match.url}/poster`} component={asyncComponent(() => import('./routes/poster'))} />
          <Route component={asyncComponent(() => import('extra/tools/routes/404/index'))} />
        </Switch>
        <PassageSlim ref='passage' items={[{ label: "个人中心", icon: KeyboardBackspaceIcon, click: () => { history.push("/app/home"); } }, { label: "退出", icon: ExitToAppOutlinedIcon, click: () => { Principal.signOut(); history.push("signin"); } }]} />
      </App>
    )
  }
}
